import sha256 from 'crypto-js/sha256'

const hashPassword = async password => {
	const hash = await sha256(password).toString()
	return hash
}

export default hashPassword
